import React, { createContext, useContext } from 'react';
export type PartnerId = 'zain' | 'etisalat';
export interface Partner {
  id: PartnerId;
  /** Display name used in headlines and body copy. */
  name: string;
  /** Official logo asset, used unmodified. */
  logo: string;
  /** Optical size correction so each logo reads at the same visual weight. */
  logoScale: number;
}
export const PARTNERS: Record<PartnerId, Partner> = {
  zain: {
    id: 'zain',
    name: 'Zain',
    logo: 'https://cdn.magicpatterns.com/uploads/v6desCRNT7CwM3FSbyjh7P/ZainBlackLogo.svg',
    logoScale: 1
  },
  etisalat: {
    id: 'etisalat',
    name: 'Etisalat',
    logo: 'https://cdn.magicpatterns.com/uploads/jowLTM1Nqd6yuPqtFK4ZLg/etisalat-logo.svg',
    logoScale: 1.45
  }
};
const PartnerContext = createContext<Partner>(PARTNERS.zain);
export function PartnerProvider({
  partner,
  children
}: {
  partner: Partner;
  children: React.ReactNode;
}) {
  return <PartnerContext.Provider value={partner} data-id="element-1268" data-mp="1m31pmxmkttl6">
      {children}
    </PartnerContext.Provider>;
}
export function usePartner() {
  return useContext(PartnerContext);
}